import { config } from '../../config/config';
import { CJS_BRAND } from '../../lib/utils';
import { BookingType } from '../../types/config';
import {
	RadioButtonComponent,
	RadioSize
} from '@vaa-component-lib/component.atom.radio';
import {
	HolidayNav,
	HolidayNavList,
	HolidayNavListItem
} from './holiday-nav.styles';

export interface HolidayNavComponentProps {
	brand: CJS_BRAND;
	selectedBookingType: BookingType;
	change: any;
}

const HolidayNavComponent = ({
	brand,
	selectedBookingType,
	change
}: HolidayNavComponentProps) => {
	return (
		<HolidayNav>
			<HolidayNavList>
				{config.bookingTypes
					.filter((bookingType: BookingType) => bookingType.brand === brand)
					.map((bookingType: BookingType, idx: number) => {
						return (
							<HolidayNavListItem key={idx}>
								<RadioButtonComponent
									{...{
										label: bookingType.name,
										id: `holidays-tab-control-${idx}`,
										value: bookingType.type,
										size: RadioSize.Sml,
										isChecked: bookingType.type === selectedBookingType.type,
										onChange: () => change(bookingType)
									}}
								/>
							</HolidayNavListItem>
						);
					})}
			</HolidayNavList>
		</HolidayNav>
	);
};

export default HolidayNavComponent;
